"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRkmValueToSiValueStr = convertRkmValueToSiValueStr;
const magnitudeMap = {
    P: 'p',
    N: 'n',
    U: 'u',
    L: 'm',
    E: '',
    R: '',
    F: '',
    V: '',
    v: '',
    H: '',
    K: 'k',
};
const unitsMap = {
    V: 'V',
    F: 'F',
    L: 'F',
    R: 'Ω',
    E: 'Ω',
};
const standardRegex = /^([+-]?)\s*(\d+)\s*(\D{1})\s*(\d*)\s*([A-Za-z]*)$/;
const alternateRegex = /^([+-]?)(\s*)(\D{1})\s*(\d+)\s*(\w*)$/;
function convertRkmValueToSiValueStr(value) {
    let wholePart;
    let fractionalPart;
    let units;
    let match;
    value = value.trim();
    match = standardRegex.exec(value);
    match = match ?? alternateRegex.exec(value);
    if (!match) {
        return undefined;
    }
    const sign = match[1];
    wholePart = match[2].trim();
    wholePart = wholePart ? wholePart : '0';
    const code = match[3].trim();
    if (!code) {
        return undefined;
    }
    const magnitude = normalizeLetterCode(code);
    fractionalPart = match[4];
    fractionalPart = fractionalPart ? '.' + fractionalPart : '';
    units = match[5];
    units = units ? units : getUnitsFromCode(code);
    return `${sign}${wholePart}${fractionalPart}${magnitude ?? ''}${units ?? ''}`;
}
function normalizeLetterCode(input) {
    if (input in magnitudeMap) {
        return magnitudeMap[input];
    }
    return input;
}
function getUnitsFromCode(code) {
    code = code.toUpperCase();
    if (code in unitsMap) {
        return unitsMap[code];
    }
    return '';
}
//# sourceMappingURL=RkmCodeValueTool.js.map